import { useToken } from "@dexteel/mesf-core";
import { Button, Grid } from "@mui/material";
import type { EditableCallbackParams } from "ag-grid-community";
import Grid2 from '@mui/material/Grid2';

type Props = EditableCallbackParams;

export const AttachmentsDownloadButtons = ({ data }: Props) => {
	const { token: bearerToken } = useToken();

	return (
		<Grid2 spacing={1}
			style={{ display: "flex", alignItems: "center" }}>
			{data?.Path && (
				<Grid2 size={{ xs: 12, md: 12 }}>
					<Button
						href={`/backend/files/${data?.UploadFileId}/download?Authorization=${bearerToken}`}
						target="_blank"
						rel="noopener noreferrer"
						variant="outlined"
						color="primary"
						sx={{
							textDecoration: "none !important",
							fontWeight: 500,
							fontSize: "12px",
							borderRadius: "3px",
						}}
						download={`${data?.FileName} `}>
						DOWNLOAD
					</Button>
				</Grid2>
			)}
		</Grid2>
	);
};
